// Store de empresas — gerenciamento de contas multi-CNPJ (titular + representadas)
import { apiGet, apiPost } from '@/api/conserv';

// Lista as empresas gerenciadas pelo usuário (titular + filhas), com status de banco e licenças
export async function listaEmpresas() {
    return apiGet('api/Empresas/ListaEmpresas');
}

// Ativa uma empresa (valida vínculo, atualiza o banco dela e retorna licenças)
export async function ativarEmpresa(cnpj) {
    return apiPost('api/Empresas/AtivarEmpresa', { cnpj });
}

// Declarações da empresa (porte ME/EPP + flags). cnpj vazio = empresa ativa
export async function getDeclaracoes(cnpj = '') {
    const extra = cnpj ? `?cnpj=${encodeURIComponent(cnpj)}` : '';
    return apiGet(`api/Empresas/Declaracoes${extra}`);
}

// Grava (upsert) as declarações de uma empresa
export async function gravaDeclaracoes(dados) {
    return apiPost('api/Empresas/GravaDeclaracoes', dados);
}
